import { useState, useEffect } from 'react';
import { database } from '../lib/supabase';
import UserProfile from '../models/UserProfile';

export function usePotentialMatchCount(localProfile: Partial<UserProfile>) {
  const [matchCount, setMatchCount] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchMatchCount = async () => {
      setIsLoading(true);
      setError(null);

      if (!localProfile) {
        return;
      }

      try {
        let query = database.flats.table().select('*', { count: 'exact' });

        // Apply filters based on the localProfile, handling null values
        if (localProfile.location_preferences && localProfile.location_preferences.length > 0) {
          query = query.in('postcode', localProfile.location_preferences);
        }

        if (localProfile.room_preferences) {
          if (localProfile.room_preferences.minRooms !== null) {
            query = query.gte('rooms', localProfile.room_preferences.minRooms);
          }
        }

        if (localProfile.budget_preferences) {
          if (localProfile.budget_preferences.max !== null) {
            query = query.or(`warm_rent.lte.${localProfile.budget_preferences.max},and(warm_rent.is.null,cold_rent.lte.${(localProfile.budget_preferences.max ?? 0) / 1.15})`);
          }
        }

        if (localProfile.size_preferences) {
          if (localProfile.size_preferences.minSize !== null) {
            query = query.gte('size', localProfile.size_preferences.minSize);
          }
        }

        // Filter only active listings
        query = query.eq('is_active', true);

        const { data, count, error } = await query;

        if (error) throw error;

        setMatchCount(count);
      } catch (err) {
        console.error('Error fetching potential match count:', err);
        setError('Failed to fetch potential match count');
      } finally {
        setIsLoading(false);
      }
    };

    fetchMatchCount();
  }, [localProfile]);

  return { matchCount, isLoading, error };
}
